import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './shared/PageNotFound/page-not-found.component';
import { AdminGuard } from './guards/admin.guard';
import { AnnotatorGuard } from './guards/annotator.guard';
import { LogoutRouteGuard } from './guards/logout.guard';


const routes: Routes = [
  {
    path: '', redirectTo: 'dashboard', pathMatch: 'full'
  },
  {
    path: 'dashboard',
    canActivate: [AdminGuard, AnnotatorGuard],
    loadChildren: () => import('./Horizon/Dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'facebook-posts',
    canActivate: [AdminGuard],
    loadChildren: () => import('./Horizon/Facebook/facebook.module').then(m => m.FacebookModule)
  },
  {
    path: 'twitter-posts',
    canActivate: [AdminGuard],
    loadChildren: () => import('./Horizon/Twitter/twitter.module').then(m => m.TwitterModule)
  },
  {
    path: 'instagram-posts',
    canActivate: [AdminGuard],
    loadChildren: () => import('./Horizon/Instagram/instagram.module').then(m => m.InstagramModule)
  },
  {
    path: 'tiktok-posts',
    canActivate: [AdminGuard],
    loadChildren: () => import('./Horizon/Tiktok/tiktok.module').then(m => m.TiktokModule)
  },
  {
    path: 'youtube-videos',
    canActivate: [AdminGuard],
    loadChildren: () => import('./Horizon/Youtube/youtube.module').then(m => m.YoutubeModule)
  },
  {
    path: 'reddit-submissions',
    canActivate: [AdminGuard],
    loadChildren: () => import('./Horizon/Reddit/reddit.module').then(m => m.RedditModule)
  },
  /*{
    path: 'logout',
    canActivate: [LogoutRouteGuard],
    component: LogoutScreenComponent,
  },*/
  {
    path: '**',
    //canActivate: [AutoLoginAllRoutesGuard],
    component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
